import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupPage } from "@/features/all-study-groups/components/StudyGroupPage";

export const Route = createFileRoute("/all-study-groups/$study-group-id")({
  component: StudyGroupPage,
});
